import { Fragment, type FC } from 'react';

// MUI
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

// screen
import { TeacherMenuModel } from 'modules/map/components/teacher-menu/types';
import SizedText from 'modules/map/components/pdf-print-form/styled-components/SizedText';
import PdfWeekday from 'modules/map/components/pdf-print-form/styled-components/PdfWeekday';
import {
  EXTRA_SMALL_FONT_SIZE,
  SMALL_FONT_SIZE,
} from 'modules/map/components/pdf-print-form/utils';
import Typography from '@mui/material/Typography';

interface FiveDaysTeacherMenuProps {
  data: TeacherMenuModel;
}
const MAX_DISHES_COUNT = 6;

const FivedaysTeacherMenu: FC<FiveDaysTeacherMenuProps> = ({ data }) => {
  const days = data.structuredData?.data?.items || [];
  const caloriesIncluded = data.structuredData.metadata.isNutritionMenu;

  const fontSize = caloriesIncluded ? SMALL_FONT_SIZE : EXTRA_SMALL_FONT_SIZE;

  return (
    <TableBody>
      {days.map((day, idx) => {
        const dishes = Array.from({ length: MAX_DISHES_COUNT }).map((_, i) => day.dishes[i] || '');
        const dishesCount = dishes.length;

        const shouldBreakNotes = day.note.includes('\n');
        const noteOfTheDay = shouldBreakNotes
          ? day.note.split('\n').map((note, index) => {
              return (
                <Typography key={index} sx={{ fontSize }}>
                  {note}
                </Typography>
              );
            })
          : day.note;

        return (
          <Fragment key={idx}>
            {dishes.map((dish, index) => {
              const isFirstRow = index === 0;

              const transparentBorderBottom = {
                borderBottom: `1px solid ${index === dishes.length - 1 ? 'auto' : 'transparent'}!important`,
              };

              return (
                <TableRow key={index}>
                  {isFirstRow && <PdfWeekday rowSpan={dishesCount} datetime={day.datetime} />}
                  <TableCell style={{ textAlign: 'left' }} sx={transparentBorderBottom}>
                    <SizedText
                      sx={{
                        fontSize,
                        display: 'inline-block',
                        px: '4px',
                        color: dish.length === 0 ? 'transparent' : 'inherit',
                      }}
                    >
                      {index + 1}. {dish}
                    </SizedText>
                  </TableCell>
                  {isFirstRow && (
                    <TableCell rowSpan={dishesCount}>
                      <SizedText sx={{ fontSize }}>{noteOfTheDay}</SizedText>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </Fragment>
        );
      })}
    </TableBody>
  );
};

export default FivedaysTeacherMenu;
